module.exports = __webpack_public_path__ + "img/facturacion.52f4b9aa.png";